import { useView } from 'hooks/view';
import { JsonEditor } from '../JsonEditor';
import { createCallback } from '../utils';

export const ViewDebug = () => {
  const { viewState, dispatchViewAction } = useView();

  return <JsonEditor {...createCallback(dispatchViewAction)} rootName='View' data={viewState} />;
};
